import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "dropbox",
  class: "row card-panel"
}
const _hoisted_2 = { class: "col s5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons right" }, "eject", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        ref: "input",
        onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleFileUpload($event))),
        type: "file",
        multiple: "",
        accept: "audio/*",
        style: {"display":"none"}
      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
      _createElementVNode("button", {
        class: "btn waves-effect waves-light",
        ref: "fileSelect",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.input.click()))
      }, [
        _createTextVNode("Files "),
        _hoisted_3
      ], 512 /* NEED_PATCH */)
    ]),
    _createVNode($setup["ShowEqualizer"])
  ], 512 /* NEED_PATCH */))
}